
export const styles = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: "31px",
        pt: "69px",
        pb: "110px",
    },
    inner: {
        width: "100%",
        maxWidth: "900px",
        display: "flex",
        gap: "50px",
        flexWrap: {xs: "wrap", md: "nowrap"},
        alignItems: "flex-start",
        pl:"25px"
    },
    downloadWrapper: {
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"
    },
    contentColumn: {
        flex: 1,
        minWidth: {xs: "100%", md: "300px"},
        maxWidth: {md: "361px"},
    },
    videoColumn: {
        flex: 1,
        minWidth: {xs: "100%", md: "380px"},
        maxWidth: {md: "466px"},
        aspectRatio: "16 / 9",
        '& .react-player__preview': {
            backgroundSize: 'contain !important',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#F8F8F8'
        }
    }
}

export interface IVideoCardProps {
    mainTitle: string;
    description: string;
    downloadText?: string;
    enableDownload?: boolean;
    videoURL?: string;
    thumbnailURL?: string;
    mainWrapperSx?: any;
    fileUrl?: string;
}